import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ViewportService } from '../../services/viewport.service';
import { APP_ROUTES } from '../../constants/app-routes.constant';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private isDesktopSubscription: Subscription;
  public isDesktop: boolean;
  public siteInstitucionalLink = 'http://www.ipesaude.rs.gov.br';

  get appRoutes() {
    return APP_ROUTES;
  }

  get bsToggle() {
    return this.isDesktop ? '' : 'collapse';
  }

  get bsTarget() {
    return this.isDesktop ? '' : '#navbarSupportedContent';
  }

  get isMyAccountRoute() {
    const route = this.router.url;

    return route.includes(APP_ROUTES.myAccount.url);
  }

  constructor(private router: Router, private viewportService: ViewportService) {}

  ngOnInit() {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
  }

  ngOnDestroy() {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }
  }
}
